// noinspection JSUnusedGlobalSymbols
// File auto-generated on: 2025-06-03T15:14:56.942Z

import {SecuritySchemes} from "~/api/extraAPIOptions.types";

export const securitySchemes: SecuritySchemes = {
    "api_key": {
        description: "API Key Security",
        type: "apiKey",
        name: "token",
        in: "query"
    },
    "api_key_header": {
        description: "API Key Security (Header).",
        type: "http",
        scheme: "bearer"
    },
    "jwt": {
        description: "JWT API Security (Header).",
        type: "http",
        scheme: "bearer",
        bearerFormat: "JWT"
    },
    "jwt-cookie": {
        description: "JWT API Security (Cookie).",
        type: "apiKey",
        name: "jwt",
        in: "cookie"
    },
    "jwt-token": {
        description: "JWT API Security (Token).",
        type: "apiKey",
        name: "jwt",
        in: "query"
    }
};
